import { render, staticRenderFns } from "./TaskSeriesVerwaltung.vue?vue&type=template&id=f521cbb8&scoped=true"
import script from "./TaskSeriesVerwaltung.vue?vue&type=script&lang=js"
export * from "./TaskSeriesVerwaltung.vue?vue&type=script&lang=js"
import style0 from "./TaskSeriesVerwaltung.vue?vue&type=style&index=0&id=f521cbb8&prod&scoped=true&lang=css"
import style1 from "./TaskSeriesVerwaltung.vue?vue&type=style&index=1&id=f521cbb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f521cbb8",
  null
  
)

export default component.exports